import { createRouter, createWebHistory } from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import About from '../views/About.vue'
import CollectionsLanding from '../views/CollectionsLanding.vue'
// import PhotoCollection from '../views/PhotoCollection.vue'
import Links from '../views/Links.vue'
import ProjectHome from '../views/projects/projectHome.vue';
// import BlogHome from '../views/blog/blogHome.vue';
import Music from '../views/Music.vue';
import { RouterLinkStub } from '@vue/test-utils'
import PhotoCollection from '../views/PhotoCollection.vue'
import Project from '../views/Projects.vue'
// import YIR2023 from '../views/blog/YIR2023.vue'
// import BlogPost from '../views/blog/blogpost.vue'
import PublicationsView from '../views/PublicationsView.vue';
import PublicationView from '../views/PublicationView.vue';
import PublicationsLanding from '../views/PublicationsLanding.vue';
import NewsView from '../views/NewsView.vue';

/* const defaults = {
	"classes":["bg-defaults"]
}

const photoMeta = {
	"classes": ["photography", ]//"bg-black"]
}
const nine8Meta = {
	"classes": ["nine8", ]//"bg-nine8"]
}
 */
const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: '/',
			name: 'home',
			component: About,
			// component: CollectionsLanding,
			// meta: defaults
		},
		{
			path: '/photography',
			name: 'photography',
			component: CollectionsLanding,
			// meta: photoMeta
		},
		{
			path: '/projects',
			component: Project,
			children: [
				{ path: '', component: ProjectHome }
			],
			// meta: nine8Meta,

		},
		{
			path: '/music',
			component: Music
		},
		{
			path: '/links',
			component: Links
		},
		{
			path: "/publications",
			component: NewsView,
			// meta: photoMeta
		},
		{
			path: "/publications/thelink",
			component: PublicationsView,
			// meta: photoMeta
		},
		{
			path:"/publications/:section/:slug",
			component: PublicationView,
			// meta: photoMeta
		},
		{
			"path":"/news",
			component: NewsView
		}
	]
})

export default router
